import { Box } from '@mui/material';
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ReactComponent as AddIcon } from "../../assets/images/add-icon.svg";
import Breadcrumb from './Breadcrumb';

const SubscriptionLayout = () => {
    const navigate = useNavigate();
    const [createPlanPageStepCount, setCreatePlanPageStepCount] =useState(0)
    const onCreatePlan = () => {
        navigate('/plan/new')
    }
   

    return (
        <>
            <Box className="subscription-parent-container">
                <Box>
                <Box className="subscription-header">
                    <Box sx={{
                        display: 'flex',
                        justifyContent: "space-between",
                        alignItems: "center",
                        height:"60px",
                        marginBottom:"30px"
                    }}>
                        <span className="SubscriptionLabel">Subscription</span>
                       {window.location.pathname === "/plans" && <button className="PlanButton" onClick={onCreatePlan}>
                            <AddIcon className="AddIcon" /> Create new plan
                        </button>}
                    </Box>
                </Box>
                <Box className='bread-crum-container'>
                <Breadcrumb currentStep={createPlanPageStepCount} changeCurrentStep={setCreatePlanPageStepCount}/>
                </Box>
                </Box>
                <Box className={"subscription-container"}>
                    <Outlet context={{createPlanPageStepCount, setCreatePlanPageStepCount}}/>
                </Box>
            </Box>
        </>
    )
}

export default SubscriptionLayout
